module.exports = __webpack_public_path__ + "static/abouthero-639fb4a35a3474788885fbe0118550e6.jpg";